import React from 'react';
import InputBox from '../../components/InputBox'

class TextBox extends React.Component {

	// Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { this._input.getValue(); }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }
	validate = () => { return this._input.validate(); }

	// React
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value
			|| nextProps.placeholder !== this.props.placeholder
			|| nextProps.disabled !== this.props.disabled);
	}

	render() {
		const props = {
			...this.props
		}

		return (<InputBox {...props} ref={(input) => { this._input = input}} />)
	}
}

export default TextBox;

// Mark this as a form component
TextBox.defaultProps = {
	formControl: true,
	managed: false
};




// WEBPACK FOOTER //
// ./src/fw/forms/controls/textBox/TextBox.js